module.exports = {
    ADD_EXAMPLE_REQUEST: "app/ADD_EXAMPLE_REQUEST",
}